// Raw item data
// {
//   "city": {
//       "_id": "654c90602e40ff6c95bc20d4",
//       "name": {
//           "en": "Seoul",
//           "ko": "서울"
//       }
//   },
//   "district": {
//       "_id": "",
//       "name": {
//           "en": "All",
//           "ko": "모두"
//       }
//   }
// },
export const parseRegionModel = (item) => {
  const type = item.district._id ? "district" : "city";
  return {
    ...item,
    _id: item.city._id + item.district._id,
    name: item[type].name,
    type,
  };
};

export const parseBusinessTypeModel = (item) => {
  const type = item.subBusinessType._id ? "subBusinessType" : "businessType";
  return {
    ...item,
    _id: item.businessType._id + item.subBusinessType._id,
    name: item[type].name,
    type,
  };
};

export const parseDutyModel = (item) => {
  const type = item.subDuty?._id ? "subDuty" : "duty";
  return {
    ...item,
    _id: item.duty._id + item.subDuty?._id,
    name: item[type].name,
    type,
  };
};
